
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor"}},[_c('path',{attrs:{"data-name":"Path 570","d":"M15.031 1.571H.969A.54.54 0 0 1 .969.5h14.062a.54.54 0 0 1 0 1.071z"}}),_c('path',{attrs:{"data-name":"Path 571","d":"M15.031 7.535H.969a.54.54 0 0 1 0-1.071h14.062a.54.54 0 0 1 0 1.071z"}}),_c('path',{attrs:{"data-name":"Path 572","d":"M15.031 13.5H.969a.54.54 0 0 1 0-1.071h14.062a.54.54 0 0 1 0 1.071z"}})])])
          )
        }
      }
    